import ActionConfirmationModal, { ActionConfirmationModalProps } from './ActionConfirmationModal';

export type { ActionConfirmationModalProps };
export default ActionConfirmationModal;
